<template>
  <div class="image-preview-button">
    <div
      class="image-wrap"
      :style="{backgroundImage: 'url(' + _image + ')' }"
      :class="{small:small,cancel:cancel,medium:medium}"
      @click="previewPopUpOpen()"
    >
      <i
        v-if="!isloading"
        class="icon-cancel delete"
        @click.stop="deleteFile()"
      />
      <div
        v-if="isloading"
        class="isloading-wrap"
      >
        <!-- <LoadingAnimate primary /> -->
        <ReloadCircleProgress
          :range="percent"
          :size="20"
          primary
        />
      </div>
      <div
        v-if="isloading"
        class="isloading-bg"
      />
    </div>
    <PreviewPopUp
      :pop-up-active="previewPopUpActive"
      :text-label="textLabel"
      download
      @click="previewPopUpClose()"
    />
  </div>
</template>
<script>
export default {
  name: "ImagePreviewButton",
  props: {
    cancel: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: "",
    },
    previewUrl: {
      type: String,
      default: "",
    },
    medium: {
      type: Boolean,
      default: false,
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    percent: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    previewPopUpActive: false,
  }),
  computed: {
    _image() {
      if (this.isloading) {
        return this.previewUrl;
      } else {
        return this.textLabel;
      }
    },
  },
  methods: {
    previewPopUpClose() {
      this.previewPopUpActive = false;
      this.$emit("scroll-click");
    },
    previewPopUpOpen() {
      if (this.isloading) return;
      this.previewPopUpActive = true;
      this.$emit("no-scroll");
    },
    deleteFile() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/image-preview-button";
</style>